
<v-container fluid class="pl-0 pr-0" v-resize="onResize">
    <c-index
        title          = "Index"
        :items         = "items"
        :criterion     = "criterion"
        :filter        = "indexFilter"
        :enable-search = "false"
        :miminize      = "false"
        :height-diff   = "140"
        @selected      = "onSelect"
        ref            = "index"
        class          = "w-75"
    >
        <template v-slot:filter>
            <v-row class="no-frame lm-border pa-3 mb-2 mt-0 pt-0">
                <v-col class="no-frame">
                    <v-text-field
                        v-model="criterion"
                        hide-details
                    />
                </v-col>
            </v-row>
        </template>

        <template v-slot:pre-filter>
            <div style="margin-top: -2px">
                <c-toolbar-button
                    v-if    = "createAllowed && settingsAdmin"
                    class   = "mr-2"
                    size    = "22"
                    icon    = "mdi-plus"
                    tooltip = "Neue Vorlage anlegen"
                    color   = "white"
                    @click  = "onCreate"
                />
            </div>
        </template>

        <template v-slot:item="{ item }">
            <div class="template-name v-flex">
                <div>
                    <div v-if="!item.deleted">{{ item.name }}</div>
                    <div v-if= "item.deleted"><s>{{ item.name }}</s></div>
                </div>
            </div>
        </template>

        <template v-slot:detail="{  }">
            <v-row class="no-frame mt-3 ml-3" >
                <v-col class="pa-0" style="min-width: 70%; max-width: 70%">
                    <div v-if="template" class="" style="height: calc(100% - 25px)">
                        <c-column-header
                            class  = "primary white--text"
                            :label = "title"
                        >
                            <template v-slot:filter>
                                <div>
                                    <a @click="onStore" class="mr-2" v-if="settingsAdmin">
                                        <v-icon size="22" color="white">mdi-content-save</v-icon>
                                    </a>
                                </div>
                            </template>
                            <template v-slot:pre>
                                <div class="white--text" v-if="settingsAdmin">
                                    <v-switch
                                        v-model = "template.deleted"
                                        class   = "pt-0 mt-1"
                                        :ripple = "false"
                                        hide-details
                                        dense
                                        color="red"
                                        @change = "onRemove"
                                    />
                                </div>
                            </template>
                        </c-column-header>

                        <div class="lm-border pa-3 mt-1">
                            <slot name="ident" v-bind:item="template" />
                        </div>

                        <div class="mt-3">
                            <v-row class="no-frame">
                                <v-col class="no-frame" >
                                    <vue-editor
                                        v-if            = "settingsAdmin"
                                        v-model         = "template.content"
                                        :editor-toolbar = "customToolbar"
                                        ref             = "editor"
                                    />
                                    <div v-if="!settingsAdmin" class="lm-border pa-3" v-html="template.content">
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>

                <v-col class="pa-0 pl-3" style="min-width: 30%; max-width: 30%">
                    <div v-if="template" class="h-100">
                        <c-column-header
                            class="primary white--text"
                            label="Variablen"
                        />
                        <div class="lm-border pa-3 w-100 mt-1" style="height: calc(100% - 46px)">
                            <div class="v-flex w-100">
                                <v-text-field
                                    v-model        = "variableFilter"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    append-icon    = "fas fa-search"
                                    class="pb-4 pl-0 pr-0 "
                                    clearable
                                    hide-details
                                />
                            </div>
                            <div v-if="variables" style="overflow-y: scroll; width: calc(100% + 10px)" :style="variableStyle">
                                <input type="hidden" id="clipboard" :value="clipboard">
                                <div
                                    v-for="(variable, index) in filteredVariables"
                                    :key="index"
                                    class="v-flex lm-border template-variable secondary lighten-4"
                                >
                                    <div class="text template-item">
                                        <a @click="onClipboard(variable)" >
                                            <div class="w-100">
                                                <v-icon color="primary">mdi-content-copy</v-icon>
                                                {{ variable.name }}
                                            </div>
                                        </a>
                                    </div>
                                    <v-spacer />
                                    <c-tag
                                        :label = "variable.contextType.name"
                                        :width = "70"
                                        :active="true"
                                        class="ml-2 mt-1 mr-1"
                                    />
                                </div>
                            </div>
                            <c-v-spacer />
                        </div>
                    </div>
                </v-col>
            </v-row>
        </template>
    </c-index>
</v-container>
